import { cache } from 'react';
import { notFound } from 'next/navigation';
import { api } from '@weareconceptstudio/core';

export const revalidate = 3600;

// ======================== Global ======================== //
export const getGlobal = cache(async ({ lang }) => {
	return await api.get({ url: 'global-data', lang });
});

// ======================== Page ======================== //
export const getPage = cache(async ({ slug, lang, params = {} }) => {
	return await api.get({ url: `${slug}`, lang, params }).catch((err) => {
		notFound();
	});
});

// ======================== Meta ======================== //
export const getMeta = cache(async ({ slug, lang }) => {
	const data = await api.get({ url: `seo/${slug}`, lang });

	return data;
});

// ======================== Portfolios ======================== //
export const getPortfolios = cache(async ({ lang, params = {} }) => {
	return await api.get({ url: 'portfolios', lang, params });
});

// ======================== Portfolio Individual ======================== //
export const getPortfolioIndividual = async ({ slug, lang, params = {} }) => {
	try {
		const data = await api.get({ url: `portfolios/${slug}`, lang, params });

		if (!data) {
			notFound();
		}

		return data;
	} catch (err) {
		notFound();
	}
};

// ======================== Faqs ======================== //
export const getFaqs = cache(async ({ lang }) => {
	const { data } = await api.get({ url: 'faqs', lang });

	return data;
});

// ======================== Featured Items ======================== //
export const getFeaturedItems = cache(async ({ lang }) => {
	const { data } = await api.get({ url: 'featured-items', lang });

	return data;
});

let cacheData = new Map();

let funcs = {
	faqs: getFaqs,
	featuredItems: getFeaturedItems,
};

export function fetchData({ name, lang, params = {} }) {
	const dataKey = `${lang}-${name}`;

	if (!cacheData.has(dataKey)) {
		cacheData.set(dataKey, funcs[name]?.({ lang, ...params }));
	}

	return cacheData.get(dataKey);
}
